module.exports = __webpack_public_path__ + "static/media/Muli-Medium.e390c0ff.eot";